﻿import { Injectable,Inject } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import {SharedService} from './sharedService'


declare var window: any;
declare function displaySystemNotification(): any;

@Injectable({
  providedIn: 'root'
})


export class DataService {

  public apiBaseUrl:string;
  public serviceUrl:string;
  public sharedService :SharedService =  new SharedService();
  public redirectionStatus:number =0;
  public success=false;
  public data= {success:false};


  readonly endpoint = environment.api_endpoint;

  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document) {

      if(this.document.location.host=="10.224.16.33:82"){
        this.endpoint="http://10.224.16.33:82//jax.service/api/v1/";
      }
      else if(this.document.location.host=="10.224.16.33:83"){
        this.endpoint="http://10.224.16.33:83//jax.service/api/v1/";
      }
      else{

      }
      this.apiBaseUrl = this.endpoint;
      this.serviceUrl = this.document.location.protocol + "//" + this.document.location.hostname + (this.document.location.port ? ":" + this.document.location.port : "");

      this.getNotificationMessage();

   }

   private getNotificationMessage(){
      this.get("common/configs").subscribe(resp => {
            this.sharedService.notificationMessage=resp;
            if(this.sharedService.notificationMessage.trim().length>0){
            window.systemMessage=this.sharedService.notificationMessage;
            window.showSystemNotification = true;
            displaySystemNotification();
            }
        });
   }

   public  get(url, params?): Observable<any> {
    return this.http.get(this.endpoint + url, { params });
  }



  public  getPdf(url, params?): Observable<any> {
    const subject: Subject<any> = new Subject();

    this.http.get(this.endpoint + url, {
      params,
      responseType: 'blob'
    }).subscribe((data) => {

      if (data.type === 'application/pdf') {
        subject.next(data);
      } else {

        let reader = new FileReader();
        reader.addEventListener('loadend', (e: any) => {
          let text = e.srcElement.result;

          let type = 'text';
          if (data.type === 'application/json') {
            type = 'json';
          } else if (data.type === 'text/html') {
            type = 'html';
          }

          if (type == 'json') {
            try {
              text = JSON.parse(text);
            } catch (e) {
              type = 'text';
            }

          }

          subject.next({ type, data: text });
        });
        reader.readAsText(data)

      }
    });

    return subject;
  }


  public  post(url, data?): Observable<any> {
    return this.http.post(this.endpoint + url, data || {});
  }

  public  postWithFile(url, data: FormData): Observable<any> {
    return this.http.post(this.endpoint + url, data);
  }

  

  public getEnvironment(): string {
    let hostName = this.document.location.hostname;
    hostName = hostName.toLowerCase();
    let pathName = this.document.location.pathname;
    let environment = "Dev";
    switch (hostName) {
        case "localhost":
        {
            environment = "Dev";
            break;
        }
        case "test.old.superiorcourt.maricopa.gov":
        {
            environment = "Test";
            break;
            }
        case "dev.old.superiorcourt.maricopa.gov":
        {
            environment = "Dev";
            break;
            }
        case "www.superiorcourt.maricopa.gov":
            {
                if (pathName.startsWith("/jaxpp/")) {
                    environment = "Test";
                } else {
                    environment = "Prod";
                }
            break;
            }
        default:
        {
            environment = "Dev";
            break;
        }
    }

    return environment;
}

  public canAccessRemovalLink(): boolean {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser.Security.search("vintJAXRemovalRequestAccess") >= 0) {
        return true;
    } else {
        return false;
    }


    
}

}